import { useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router';
import { ArchVisionCanvas } from './ArchVisionCanvas';
import { ModelStatus } from 'pages/ModelStatus';
import { useModelLoader } from 'hooks';
import {
  clearUpdateData,
  clearSerializedData,
  setGuidURL,
  setReinitializeCanvas,
  setExportModel,
  setExportedModelData,
} from 'store/actions/canvasActions';
import { CanvasContainer } from './styles';
import constants from 'constants';

const { VIEWER_MODEL_FORMAT } = constants;

const ArchVision = () => {
  const { pathname } = useLocation();
  const dispatch = useDispatch();

  const guid = pathname.split('archvision/')[1];
  const loader = useModelLoader({ guid, format: VIEWER_MODEL_FORMAT });

  const cleanup = useCallback(() => {
    dispatch(clearUpdateData());
    dispatch(clearSerializedData());
    dispatch(setGuidURL(null));
    dispatch(setReinitializeCanvas(false));
    dispatch(setExportModel(false));
    dispatch(setExportedModelData(null));
  }, [ dispatch ]);

  useEffect(() => {
    return () => cleanup();
  }, [ cleanup ]);

  return (
    <CanvasContainer>
      {loader.showStatus
        ? <ModelStatus {...loader.statusProps} />
        : <ArchVisionCanvas previewURL={loader.previewURL} />
      }
    </CanvasContainer>
  );
};

export { ArchVision };
